import { MEDIA_TYPES } from '../constants';

const getMimeTypeByMediaType = (mediaType) => {
  switch (mediaType) {
    case MEDIA_TYPES.IMAGE:
      return 'image/png';
    case MEDIA_TYPES.VIDEO:
      return 'video/mp4';
    default:
      return 'application/octet-stream';
  }
};

export default getMimeTypeByMediaType;
